import { IconProps } from "@/data/types"

export default function RooftopTerraceIcon({
  width = 32,
  height = 32,
  color = "#000000",
  className,
}: IconProps) {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <g strokeLinecap="round" strokeLinejoin="round">
          <polyline
            points="0.55 1.5 22.5 3.41 22.5 6.27 0.55 6.27"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
          <line
            x1="20.59"
            y1="6.27"
            x2="20.59"
            y2="22.5"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
          <line
            x1="23.45"
            y1="22.5"
            x2="0.55"
            y2="22.5"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
          <polyline
            points="4.36 12.96 5.32 18.68 5.32 22.5"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
          <polyline
            points="5.32 22.5 5.32 18.68 9.14 18.68 9.14 22.5"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
          <line
            x1="9.14"
            y1="15.82"
            x2="16.77"
            y2="15.82"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
          <line
            x1="12.95"
            y1="22.5"
            x2="12.95"
            y2="15.82"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
        </g>
      </svg>
    </div>
  )
}
